<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- Filter Search -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="Mobile / Email" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="Mobile or email (optional)" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="Member ID" prop="userCode">
                <a-input v-model="queryParam.userCode" placeholder="Member ID (user code)" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="Name" prop="nameKeyword">
                <a-input v-model="queryParam.nameKeyword" placeholder="First or last name" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="Nickname" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="Please enter nickname" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="Gender" prop="sex">-->
<!--                <a-select placeholder="Please select gender" v-model="queryParam.sex" style="width: 100%" allow-clear>-->
<!--                  <a-select-option :key="0" >Unknown</a-select-option>-->
<!--                  <a-select-option :key="1" >Male</a-select-option>-->
<!--                  <a-select-option :key="2" >Female</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="User Status" prop="status">-->
<!--                <a-select placeholder="Please select user status" v-model="queryParam.status" style="width: 100%" allow-clear>-->
<!--                  <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="Email" prop="email">-->
            <!--                <a-input v-model="queryParam.email" placeholder="Please enter email" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <template v-if="advanced">


              <a-col :md="8" :sm="24">
                <a-form-item label="Invitation Code" prop="invitationCode">
                  <a-input v-model="queryParam.invitationCode" placeholder="Please enter invitation code" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="Push Enabled" prop="isNotice">
                  <a-select placeholder="Please select push status" v-model="queryParam.isNotice" style="width: 100%" allow-clear>
                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? 'Collapse' : 'Expand' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- Operations -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.addUserForm.handleAdd()">
          <a-icon type="plus" />Add
        </a-button>

        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" style="margin-bottom: 20px;" />
      </div>
      <!-- Create and Update -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <add-user-form ref="addUserForm" @ok="getList" />
      <reset-password ref="resetPassword" />
      <edit-member-id ref="editMemberId" @ok="getList" />
      <!-- Data Table -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :scroll="{x:true}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>

        <!--        <span slot="status" slot-scope="text, record">-->
        <!--          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>-->
        <!--        </span>-->

        <!--        <span slot="status" slot-scope="text, record">-->
        <a-switch slot="status" slot-scope="text, record" v-model="record.status" @change="onChange($event,record)" />
        <!--          <a-switch v-lacksPermi="['biz:user:status']" v-model="record.status" :disabled="true" />-->
        <!--        </span>-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.editMemberId.show(record)">
            <a-icon type="form" />Edit Member ID
          </a>
          <a-divider type="vertical" />
          <a @click="$refs.resetPassword.handleResetPwd(record)" >
            <a-icon type="edit" />Reset Password
          </a>
          <a-divider type="vertical" />
          <a @click="$refs.createForm.handleUpdate(record)" >
            <a-icon type="plus" />Top Up Balance
          </a>
          <a-divider type="vertical" />
          <a class="danger-link" @click="handleDelete(record)">
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <!-- Pagination -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getDetailUser, listUser, delUser, updateUser } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import AddUserForm from './modules/AddUserForm'
import { tableMixin } from '@/store/table-mixin'
import ResetPassword from './modules/ResetPassword'
import EditMemberId from './modules/EditMemberId'
export default {
  name: 'User',
  components: {
    AddUserForm,
    CreateForm,
    ResetPassword,
    EditMemberId
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // Advanced search toggle
      advanced: false,
      // Disable when not single-selected
      single: true,
      // Disable when no multi-selection
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // Query params
      queryParam: {
        mobile: null,
        userCode: null,
        nameKeyword: null,
        email: null,
        nickname: null,
        sex: undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Mobile Code',
          dataIndex: 'mobileCode',
          align: 'center'
        },
        {
          title: 'Mobile',
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: 'First Name',
          dataIndex: 'firstName',
          align: 'center'
        },
        {
          title: 'Last Name',
          dataIndex: 'lastName',
          align: 'center'
        },
        {
          title: 'Email',
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Nickname',
          dataIndex: 'nickname',
          align: 'center'
        },
        {
          title: 'Member ID',
          dataIndex: 'userCode',
          align: 'center'
        },
        // {
        //   title: 'Gender',
        //   dataIndex: 'sex',
        //   align: 'center',
        //   width: 80,
        //   customRender(t,r) {
        //     if(r.sex == 0) {
        //       return 'Unknown';
        //     } else if(r.sex == 1) {
        //       return 'Male';
        //     } else if(r.sex == 2) {
        //       return 'Female';
        //     }
        //   }
        // },
        // {
        //   title: 'Birthday',
        //   dataIndex: 'birthday',
        //   align: 'center',
        //   width: 100,
        // },
        // {
        //   title: 'Profile',
        //   dataIndex: 'userSign',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 100,
        // },
        {
          title: 'Balance',
          dataIndex: 'money',
          align: 'center',
          width: 100,
        },
        // {
        //   title: 'Invitation Code',
        //   dataIndex: 'invitationCode',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: 'Push Enabled',
        //   dataIndex: 'isNotice',
        //   scopedSlots: { customRender: 'isNotice' },
        //   align: 'center'
        // },
        // {
        //   title: 'User Status',
        //   dataIndex: 'status',
        //   width: 100,
        //   scopedSlots: { customRender: 'status' },
        //   align: 'center'
        // },
        {
          title: 'Registration Time',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: 'Actions',
          dataIndex: 'operation',
          width: 360,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    openXinde(record) {
      this.$refs.cityArticleForm.show({
        userId:record.id,
        id: null,
        type:1
      })
    },
    onChange(e,record) {
      let recordData =JSON.parse(JSON.stringify(record));
      recordData.status = e ? 1 : 0;
      this.updateData(recordData);
      record.status = e ? 1 : 0;
    },
    updateData(record) {
      updateUser(record).then(res => {
        console.log(res);
        if(res.code == 20001) {
          this.$message.success("Operation succeeded");
        } else {
          this.$message.error(res.message);
        }
      })
    },
    /** Query user list */
    getList () {
      this.loading = true
      const params = { ...this.queryParam }
      ;['mobile', 'userCode', 'nameKeyword', 'nickname', 'email'].forEach(k => {
        if (params[k] != null && params[k] !== '') {
          params[k] = String(params[k]).trim()
        }
      })
      getDetailUser(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** Search action */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** Reset action */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        userCode: undefined,
        nameKeyword: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** Delete single user (logical delete on server) */
    handleDelete (row) {
      const idList = row && row.id != null ? [row.id] : [...this.ids]
      if (!idList.length) {
        this.$message.warning('No user selected')
        return
      }
      const that = this
      this.$confirm({
        title: 'Delete this customer?',
        content: 'User ID(s): ' + idList.join(', ') + '. Related wallet row will be removed. This cannot be easily undone.',
        okType: 'danger',
        onOk () {
          const data = idList.map(id => ({ id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('Deleted successfully')
            })
        }
      })
    },
    /** Export action */
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Confirm export?',
        content: 'This will export all data under current filters, not just selected rows.',
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `user_info_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.danger-link {
  color: #ff4d4f;
}
</style>
